import React from "react";
import Card from "./Card";
import Navbar2 from "./Navbar";
import sala1 from "../assets/cbbSala1.jpg";
import sala2 from "../assets/cbbSala2.jpg";
import sala3 from "../assets/cbbSala3.jpg";
import sala4 from "../assets/cbbSala4.jpg";
import sala5 from "../assets/cbbSala5A.jpg";
import comedor from "../assets/CBBComedorD.jpg";
import "../cbb-cards.css";



const cards = [
     {
        id: 10,
        Nombre: "Sala 1",
        Edificio: "CBB",
        N_piso: "5",
        Tamaño: "Mediana",
        N_personas: "12",
        Estado: "Disponible",
        img: sala3,
        img2: sala3
    },
    {
        id: 8,
        Nombre: "Sala 2",
        Edificio: "CBB",
        N_piso: "5",
        Tamaño: "Grande",
        N_personas: "18",
        Estado: "Disponible",
        img: sala1,
        img2: sala1
    },
    {
        id: 9,
        Nombre: "Sala 3",
        Edificio: "CBB",
        N_piso: "5",
        Tamaño: "Grande",
        N_personas: "18",
        Estado: "Disponible",
        img: sala2,
        img2: sala2
    },
   
    {
        id: 11,
        Nombre: "Sala 4",
        Edificio: "CBB",
        N_piso: "5",
        Tamaño: "Mediana",
        N_personas: "12",
        Estado: "Disponible",
        img: sala4,
        img2: sala4
    },
    {
        id: 12,
        Nombre: "Sala 5",
        Edificio: "CBB",
        N_piso: "5",
        Tamaño: "Mediana",
        N_personas: "12",
        Estado: "Disponible",
        img: sala5,
        img2: sala5
    },
    {
        id: 30,
        Nombre: "Comedor",
        Edificio: "CBB",
        N_piso: "5",
        Tamaño: "Grande",
        N_personas: "80",
        Estado: "Disponible",
        img: comedor,
        img2: comedor
    }

];



function Cards3() {
     return (
            <div className="rs-cbb-page">
                <Navbar2 />

                <section className="rs-cbb-hero">
                    <h2>CBB</h2>
                    <p>Explora las salas disponibles y crea tu solicitud de reserva rapidamente.</p>
                </section>

                <div className="rs-cbb-grid">
                    {cards.map((card) => (
                        <article className="rs-cbb-item" key={card.id}>
                            <Card
                                id={card.id}
                                Nombre={card.Nombre}
                                Edificio={card.Edificio}
                                N_piso={card.N_piso}
                                Tamaño={card.Tamaño}
                                N_personas={card.N_personas}
                                Estado={card.Estado}
                                img={card.img}
                                img2={card.img2}
                            ></Card>
                        </article>
                    ))}
                </div>
            </div>
        );
}

export default Cards3;
